export const TOAST_EVENT = 'blitz:toast';

export function dispatchToast(message, type = 'info') {
  try {
    if (
      typeof window === 'undefined'
      || typeof window.dispatchEvent !== 'function'
      || typeof CustomEvent !== 'function'
    ) return;
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, {
      detail: { message, type },
    }));
  } catch {}
}
